import { store } from "../../..";
import { API } from "../../../../legacy/api";
import * as validate from "../../../validation";
import * as actions from "../../Dialogs/Common/Dialogs.actions";
import { IShowDialog } from "./Dialogs.actions";

API.on("dialog.show", (dialog: IShowDialog) => {
  if (validate.dialogOptions(dialog)) {
    store.dispatch(actions.showDialog(dialog.options));
  }
});

API.on("dialog.hide", () => {
  const showing = store.getState().dialogs.showing;

  if (showing) {
    store.dispatch(actions.hideDialog());
  }
});
